import { dateFormatConfig, phoneFormatConfig ,EQUALS, NOT_EQUALS, CONTAINS, CASE_STATUS_ACTIVE} from "./constants";
import moment from "moment";
import momentTZ from "moment-timezone";
import sessionService from "@services/session.service";
import axios from "axios";
import { isNil  , isNumber , isString , isNaN , isEmpty , trim , map, get} from "lodash";

export function parseToken(token: string): string {
  return JSON.parse(atob(token.split(".")[1]).toString());
}

export function userFromToken(token: string): any {
  const payload: any = parseToken(token);
  return payload.userId;
}

export function isTokenExpired(token: string): boolean {
  const payload: any = parseToken(token);
  return payload.exp < Date.now() / 1000;
}

export function responseHeaders(headers: string): any {
  const headerPairs = headers.split("\r\n");

  const _headers: any = {};

  headerPairs.forEach((line: string) => {
    line = line.trim();

    if (line) {
      const parts = line.split(":");
      _headers[parts[0].trim()] = parts[1].trim();
    }
  });

  return _headers;
}

export function validateEmail(email: string): any {
  var emailCheck =
    /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i;
  return emailCheck.test(email);
}


export function formatNumber(num:any): any {
  return String(num).replace(/(.)(?=(\d{3})+$)/g,'$1,');
  /* const nf = Intl.NumberFormat();
  return nf.format(num); */
}

export function isValidNumber(str: any): any {
  const regex = /^[-,0-9]+$/;
  if(regex.test(str))
    return true;

  return false;
}

export function isValidTime(str: any, is24Format?:boolean): any {
  const regex = is24Format ? /^([01]\d|2[0-3]):?([0-5]\d)$/ :  /((1[0-2]|0?[1-9]):([0-5][0-9]) ?([AaPp][Mm]))/;
  if(regex.test(str))
    return true;

  return false;
}

///////////////////////////////////////////////////////////////////////////////////////////

export const getClientName = () => {
  let clientN: any  = sessionService.getClient() || {};
  return clientN["clientName"];
}

export const getUser = () => {
  const user = JSON.parse(localStorage.getItem("_user") || '');
  return `${get(user ,'firstName', '')}, ${get(user ,'lastName', '')}`;
}

export const getFormateForClient = () => {
  return dateFormatConfig.get("Tredence")["longDateFormatHyphen"];
}

export const longDateTimeFormatHyphen = (date:any) =>{
  let clientName = getClientName();
  return moment.utc(date, dateFormatConfig.get(dateFormatConfig.get(clientName)["actualFormat"])).local().format(dateFormatConfig.get(clientName)["actualFormat"]);
}

export const longDateFormatHyphen = (date:any) =>{
  let clientName = getClientName();
  return moment.utc(date, dateFormatConfig.get(dateFormatConfig.get(clientName)["actualFormat"])).format(dateFormatConfig.get(clientName)["longDateFormatHyphen"]);
}

export const longDateFormat = (date:any) =>{
  let clientName = getClientName();
  return moment.utc(date, dateFormatConfig.get(dateFormatConfig.get(clientName)["actualFormat"])).format(dateFormatConfig.get(clientName)["longDateFormat"]);
}

export const shortDateFormat = (date:any) =>{
  let clientName = getClientName();
  return moment.utc(date, dateFormatConfig.get(dateFormatConfig.get(clientName)["actualFormat"])).local().format(dateFormatConfig.get(clientName)["shortDateFormat"]);
}

///Remainder drawer calender 474
export const shortDateRemainder = (date:any) => {
  let clientName = getClientName();
  return moment.utc(date, dateFormatConfig.get(dateFormatConfig.get(clientName)["actualFormat"])).local().format("Do MMM, YYYY");
}

export const shortNoteDateFormat = (date:any) => {
  let clientName = getClientName();
  return moment.utc(date, "DD-MM-YYYY HH:mm:ss").local().format(dateFormatConfig.get(clientName)["shortDateFormat"]);
}
// export const formatDateStandard = (date:any) =>{
//   let clientName = getClientName();
//   return moment(date).format(dateFormatConfig.get(clientName)["formate"]);
// }moment.utc(notificationDate).local().format("Do MMM | h:mm a")

// export const formatDefaultDate = (date:any) =>{
//   let clientName = getClientName();
//   return moment(date).format(dateFormatConfig.get(clientName)["format"]);
//}


export const formatDateTimeLocal = (date:any) => {
  let clientName = getClientName();
  return moment.utc(date).local().format(dateFormatConfig.get(clientName)["formatLocalDateTime"]);
  // moment.utc(currentMember?.caseLastActionDate).local().format("DD MMM YYYY, hh:mm a")
}

export const formatDateWithTimeAndPipe = (date:any) =>{
  let clientName = getClientName();
  return moment.utc(date, dateFormatConfig.get(dateFormatConfig.get(clientName)["actualFormat"])).format(dateFormatConfig.get(clientName)["formatWithPipe"]);
}

export const formatDateForReminder = (date:any) =>{
  let clientName = getClientName();
  return moment(date, dateFormatConfig.get(dateFormatConfig.get(clientName)["actualFormat"])).format(dateFormatConfig.get(clientName)["formatDateForReminder"]);
}

export const formatTimeForReminder = (date:any) =>{
  let clientName = getClientName();
  return moment(date, dateFormatConfig.get(dateFormatConfig.get(clientName)["actualFormat"])).format(dateFormatConfig.get(clientName)["formatTimeForReminder"]);
}

export const formatCreateDate = (date:any) =>{
  let clientName = getClientName();
  return moment.utc(date, dateFormatConfig.get(dateFormatConfig.get(clientName)["actualFormat"])).format(dateFormatConfig.get(clientName)["LastActionFormat"]);
}

export const formatLastGapClosed = (date : any) => {
  let clientName = getClientName();
  return moment.utc(date, dateFormatConfig.get(dateFormatConfig.get(clientName)["actualFormat"])).format(dateFormatConfig.get(clientName)["LastGapClosedFormat"]);
}

export const formatLastActionTaken = (date : any) => {
  let clientName = getClientName();
  return moment.utc(date, dateFormatConfig.get(dateFormatConfig.get(clientName)["actualFormat"])).format(dateFormatConfig.get(clientName)["LastActionFormat"]);
}

/**
 * @param date Date that needs to be converted to requried format.
 * @param currentDateFormat required when the format of the Date is different than "actualFormat: DD-MM-YYYY HH:mm:ss".
 * @param neededDateFormat required when required display format of Date is different than "defaultDateFormat: MM-DD-YYYY".
 * @param convertToLocal required time zone  
 */
export const formatDisplayDate = (date: any, currentDateFormat: string = "", neededDateFormat: string = "", convertToLocal: boolean = false) => {
  if (typeof date === "string" && (date?.includes("1900-01-01") || date?.includes("01-01-1900"))) {
    return "--";
  } else {
    let clientName = getClientName();
    const originalDateFormat = currentDateFormat === "" ? "actualFormat" : currentDateFormat;
    const requiredDateFormat = neededDateFormat === "" ? "defaultDateFormat" : neededDateFormat;

    let time = moment.utc(date, dateFormatConfig.get(clientName)[originalDateFormat]);

    if (convertToLocal) {
      time.local();
    }

    return time.format(dateFormatConfig.get(clientName)[requiredDateFormat]);
  }
};

export const formatDateWithoutConversion = (date: any, currentDateFormat: string = '' , neededDateFormat: string = '') => {
  let clientName = getClientName();
  const originalDateFormat = currentDateFormat === '' ? "actualFormat" :  currentDateFormat;
  const requiredDateFormat = neededDateFormat === '' ? "defaultDateFormat" : neededDateFormat;

  let time = moment(date, dateFormatConfig.get(clientName)[originalDateFormat])

  return time.format(dateFormatConfig.get(clientName)[requiredDateFormat]);       
}

export const localToUTCFormatDate = (date: moment.MomentInput) => {
  return moment.utc(moment(date)).format();
}

export const utcToLocalFormatDate = (date: moment.MomentInput) => {
  return moment.utc(date).local().format("YYYY-MM-DD HH:mm:ss")
}

export function formatPhoneNumber(phoneNumberString : string , formatNeeded : string) {
  let clientName = getClientName();
  if(phoneFormatConfig.get(clientName)[formatNeeded]) {
    var cleaned = ('' + phoneNumberString).replace(/\D/g, '');
    var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
    if (match) {
      var intlCode = (match[1] ? '+1 ' : '+1 ');
      return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('');
    }
    return phoneNumberString;
  }
}

export const changeDateFormatinDescription = (description : string, converToLocal: boolean = true) => {
    let firstindex = description?.indexOf('$|');
    let lastIndex = description?.lastIndexOf('$|');
    if(firstindex >= 0 && lastIndex >= 0){
      const date = formatDisplayDate(description.slice(firstindex + 2 , lastIndex) , "reminderDateActualFormat" , "defaultDateFormatWithTime", converToLocal);
      description = description.replace(description.substring(firstindex , lastIndex + 2) , "");
      const result = description.slice(0, firstindex) + date + description.slice(firstindex);
      return result;
    } 
    return description
}

// Use this for cost formatting
export const fixedDecimal = (num : number , decimalplaces : number) => {
  let numeric = (Math.round(num * 100) / 100).toFixed(decimalplaces).split(".");
  return (+numeric[0]).toLocaleString() + (numeric[1] ? "." +  numeric[1] : "");
}

export const formatDownloadFileNameDate = (val : Date) => {
  return ("0" + (val.getMonth() + 1)).slice(-2) + "_" + ("0" + val.getDate()).slice(-2) + "_" +  val.getFullYear() + "_" +
  ("0" + (val.getHours())).slice(-2) + "_" +  ("0" + (val.getMinutes())).slice(-2) + "_" + ("0" + (val.getSeconds())).slice(-2)
}

export const formatDownloadDate = (val : Date) => {
  return ("0" + (val.getMonth() + 1)).slice(-2)  + "/" + ("0" + val.getDate()).slice(-2)  + "/" + val.getFullYear() + " " + 
  ("0" + (val.getHours())).slice(-2) + ":" +  ("0" + (val.getMinutes())).slice(-2) + ":" + ("0" + (val.getSeconds())).slice(-2)
}

export const getDateWithLocalTimeZone = (val : any , timeZoneRequired : boolean = false) => {
  let clientName = getClientName();
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  return momentTZ(val).tz(timezone).format(dateFormatConfig.get(clientName)[timeZoneRequired ? 'dateTimeColumnFilterDisplayFormat' : "refreshDateFormat"]);
}

export const getReportUpdatedDateTime = (val : any , timeZoneRequired : boolean = false) => {
  let clientName = getClientName();
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  return momentTZ(val).tz(timezone).format(dateFormatConfig.get(clientName)[timeZoneRequired ? 'reportUpdatedDateTimeFormat' : "refreshDateFormat"]);
}

export const emailValidationWithAllowedDomains = (email : string, fieldName : string , allowedDomains : string[] , usersData : Array<any>) => {
  if (!email || !email.length) {
    return `${fieldName} is required`;
  } else if(usersData.length > 0 && usersData.findIndex((user : any) => user.user_email === email) > -1){
    return `${fieldName} is already exists`;
  }
  const emailDomain = email.split('@').pop()
  const isAllowed = allowedDomains.includes(emailDomain || '')

  let error = "";
  if (!email.match(/^\S+@\S+\.\S+$/) || !isAllowed) {
    error = `${fieldName} is invalid or not allowed`
  } 
  return error;
}


export const inputValidation = (val : string , fieldName : string) => {
  if(!val || !(val.trim().length > 0)) {
    return `${fieldName} is Required`
  }  else {
    return "";
  }
}

export const phoneNumberValidation = (val : string , fieldName : string) => {
  if(!val) {
    return `${fieldName} is required`;
  }else if(val.indexOf('_') > 0){
    return `${fieldName} is Invalid`
  }
  return ""
}

export const genderValidation = (val : string , fieldName : string , possibleValues : string[] = []) => {
  if(!(possibleValues.indexOf(val) > -1)){
    return `${fieldName} is Required or Invalid`
  }
  return ""
}

export const primaryOfficeValidation = (primaryOfficeval : string , fieldName : string , secondaryOffice : any , userRole : string) => {
  if(!primaryOfficeval && !secondaryOffice.value && !['ReportUser','ReportUserAdmin'].includes(userRole)){
    return `${fieldName} or ${secondaryOffice.displayName} is required`
  }
  return "";
}

export const secondaryOfficeValidation = (secondaryOfficeval : string , fieldName : string , primaryOffice : any , userRole : string) => {
  if(primaryOffice.value && secondaryOfficeval && !['ReportUser','ReportUserAdmin'].includes(userRole)){
    if(primaryOffice.value === 'ALL' && secondaryOfficeval?.length > 0){
      return `${fieldName} cannot have ${primaryOffice.displayName} fields`
    } else if (compareArrayForNoSimilarity(primaryOffice.value.split('$|') , secondaryOfficeval.split('$|'))) {
      return `${fieldName} cannot have ${primaryOffice.displayName} fields`
    } else if (secondaryOfficeval === 'ALL' && primaryOffice?.value?.length > 0 ) {
      return `${fieldName} cannot have ${primaryOffice.displayName} fields`
    }
  }
  return "";
}

export const compareArrayForNoSimilarity = (arr1 : any , arr2 : any) => {
  return arr1.some((ar : any)  => arr2.indexOf(ar) > -1);
}

export const getAllowedDomains = (setFunc: any) => {
  axios.get(`${process.env.REACT_APP_API_BASE_URI}/domain/domains`)
    .then((response) => {
      const domains = response.data?.data?.domains || [];
      let allowedDomains = [];
      const clientName = domains.find((domain: any) => domain.user_domain_name === sessionService.getUser().email.split("@").pop()).client_name;
      if (clientName === "Tredence" || clientName === "Tredence Dev") {
        allowedDomains = domains.map((domain: any) => domain.user_domain_name);
      } else {
        allowedDomains = domains.filter((domain: any) => domain.client_name === clientName).map((domain : any) => domain.user_domain_name);
      }
      setFunc(allowedDomains);
    })
    .catch((error) => {
      console.log(error);
      setFunc([]);
    });
};

//compareArrays returns true if two arrays have elements may not be in same order
export const compareArrays = (arr1 : Array<any>, arr2 : Array<any>) => {
  if(!arr1 && !arr2){
    return true;
  } else if (!arr1 || !arr2){
    return false;
  } else if(arr1 && arr2) {
    return (arr1.length === arr2.length) && arr1.every((arr : Array<any>) => arr2.indexOf(arr) > -1);
  }
}
//checks if array is not empty and it has no null or undefined values

export const arrayNullAndEmptyValidation = (arr : Array<any> | string , filterType ?: string) => {
  if(Array.isArray(arr)) {
    if(filterType === "range" && arr.length < 2){
      return false;
    }
    return  arr && arr.length > 0 && arr.every((a) => a === 0  || a);
  } else if(typeof arr === "string") {
       return arr?.trim()?.length > 0;
      }
}

//returns false if object is empty or all values of objects are null || undefined || false || '' 
export const objectValuesChecker = (obj : any) => {
  const val = Object.values(obj);
  return val.some((v : any) => v);
} 

export const ellipsis = (text : string , size : number) => {
  if (text?.length > size) {
    return text?.substring(0, size) + "...";
  } else {
    return text;
  }
}

//to change comma separated string to number
export const parseNumber = (number : string) => {
  return parseFloat(number?.replace(/,/g, ''));
}

//to trim to values in array of strings
export const trimArray = (arr : Array<string>) => {
  if(Array.isArray(arr)){
    arr = arr.map((a) => a.trim())
  }
  return arr;
}

export const getColumn = (columns : any, key : string , parentColRequired = false) => {
  let column : any = {};
  columns.forEach((col : any) => {
      if(col.dataIndex === key){
        column = col;
          return;
      } else if(col.subColumns && col.subColumns.length > 0){
          col.subColumns.forEach((c : any) => {
              if(c.dataIndex === key){
                column = parentColRequired ? col : c;
                  return;
              }
          })
      }
  })
  return column;
}

export const getInputTime = (addMinutes = 0) => {
  const currentTime = moment();
  
  // Round up to the next multiple of 15 minutes
  let nextTime = moment()
    .startOf('hour')
    .add(Math.ceil(currentTime.minutes() / 15) * 15, 'minutes');

  if(addMinutes) {
    nextTime.add(15, 'minutes');
  }

  return nextTime.format('HH:mm');
}

export const caseLessComparision : any = (val1 : string, val2 : any , operation : string = EQUALS , comparisionType : string = '') => {
  if(comparisionType === CONTAINS) {
    val2 = (val2 || '').split('$|');
    let lowercaseArray : any = map(val2, function(element : string) {
      return element.toLowerCase();
    });
    if(operation === EQUALS) {
      return lowercaseArray.includes(val1?.toLowerCase());
    } else if(operation === NOT_EQUALS){
      return !lowercaseArray.includes(val1?.toLowerCase());
    }
  } else {
    if(operation === EQUALS) {
      return val1?.toLowerCase() === val2?.toLowerCase()
    } else if(operation === NOT_EQUALS){
      return val1?.toLowerCase() !== val2?.toLowerCase()
    }
  }
}

//the below function can be removed once the required db changes are done
export const milleniumClientCheck = () => {
  const clientName = getClientName();
  if (process.env.REACT_APP_ENVIRONMENT === "demo") {
    return false
  }
  if (clientName === "Millennium" || clientName === "Tredence Dev") {
    return true;
  }
}

export function patientReadOnlyCalc(cm_primary_patient: string): string {
  return cm_primary_patient === 'N' ? 'Y' : 'N'
}

export const getDisplayValueBasedOnType = (value : string , type ?: string) => {
  if(type === 'percent') {
    return !isNil(value) ? `${value} %` : 'N/A'
  } else if(type === 'dollar'){
    return !isNil(value) ? `$ ${value}` : 'N/A'
  } else {
    return `${value ?? 'N/A'}`
  } 
}

export const isNumberOrNumberString = (value : number | string) => {
  return isNumber(value) || (isString(value) && !isNaN(Number(value)));
}


/*Number(null) is 0 to avoid the below function can be used*/
export const stringToNum = (num : any) => {
  if(isNumberOrNumberString(num)){
    return Number(num);
  } else {
    return;
  }
}

export function isNotEmptyOrWhiteSpace(value : string | number) {

  if(value === 0) {
    return true
  }

  // Check if the value is not null or undefined and not an empty string or a string with only spaces
  return !isEmpty(value) && isString(value) && !isEmpty(trim(value));
}

export function getPasswordSecret(): string {
  return window.location.hostname
}
export const isAutoCaseStatus = (forceStatus?: string) => {
  if (forceStatus) {
    return forceStatus
  }
  if (!milleniumClientCheck()) {
    return CASE_STATUS_ACTIVE;
  }
}
export function getNoteMaxLength() {
  return stringToNum(process.env.REACT_APP_NOTE_CONTENT_LENGTH) || 2000;
}
export function getReminderMaxLength() {
  return stringToNum(process.env.REACT_APP_REMINDER_CONTENT_LENGTH) || 1000;
}


export function getOrdinal(number : number) {

  if(typeof number === 'string') {
    number = parseInt(number);
  }
  // Check if the number is between 10 and 20, as these have special suffixes
  if (number >= 10 && number <= 20) {
      return number + "th";
  }

  // For other numbers, determine the suffix based on the last digit
  const lastDigit = number % 10;
  switch (lastDigit) {
      case 1:
          return number + "st";
      case 2:
          return number + "nd";
      case 3:
          return number + "rd";
      default:
          return number + "th";
  }
}

export const centricClientCheck = () => {
  const clientName = getClientName();
  
  if (clientName === "Centric") {
    return true;
  }
}

export const showHeaderGlobalSearchAndNotification = () => {
  const clientName = getClientName();
  const hideGlobalSearchForClient = ["Centric", "Wellbe"]
  return hideGlobalSearchForClient.includes(clientName)
}

export const healthPlanNameMapping = {
  AETNA: "Aetna",
  "BRAND NEW DAY": "BND",
  "HEALTH NET": "HealthNet",
  "CENTRAL HEALTHPLAN": "Central Health Plan",
};

export const getTransformedHealthPlanName = (normalizedHealthPlanName?: string): string | undefined => {
  if (!normalizedHealthPlanName) return undefined;

  const matchedKey = Object.keys(healthPlanNameMapping).find((key) => key.toLowerCase() === normalizedHealthPlanName.toLowerCase());

  return matchedKey ? healthPlanNameMapping[matchedKey as keyof typeof healthPlanNameMapping] : undefined;
};

// Disabling / Hiding weather data
export const disableWeatherData = () => {
  const clientName = getClientName();
  if (clientName === "Millennium" || clientName === "Tredence Dev" || clientName === "Centric") {
    return true;
  } else {
    return false
  }
}

export const stripHtmlTags = (html: any) => {
  const doc = new DOMParser().parseFromString(html, "text/html");

  doc.querySelectorAll("p, br, div").forEach((el) => {
    el.replaceWith(" " + el.textContent);
  });

  return (doc.body.textContent || "")
    .replace(/\u00A0/g, " ")
    .replace(/\s+/g, " ")
    .trim();
};

export const getPlainTextLength = (html: string = "") => {
  return stripHtmlTags(html).length;
};

export const sanitizeInput = (value: string, type: string): string => {
  switch (type) {
    case "alphaOnly":
      return value.replace(/[^a-zA-Z]/g, "");

    case "alphaWithSpecial":
      return value.replace(/[^a-zA-Z'\-\s]/g, "");

    case "alphanumeric":
      return value.replace(/[^a-zA-Z0-9]/g, "");

    case "alphanumericWithDot":
      value = value.replace(/[^a-zA-Z0-9.]/g, "");
      // Prevent multiple dots
      if ((value.match(/\./g) || []).length > 1) {
        value = value.replace(/\.+$/, "");
      }
      return value;

    case "alphanumericWithSpecialSymbol":
      return value.replace(/[^a-zA-Z0-9!@#\$%\^\&*\)\(+=._-]/g, "");

    case "number":
      return value.replace(/[^0-9]/g, "");

    case "numberWithDot":
      value = value.replace(/[^0-9.]/g, "");
      if ((value.match(/\./g) || []).length > 1) {
        value = value.replace(/\.+$/, "");
      }
      return value;

    case "numberWithSpecialSymbol":
      return value.replace(/[^0-9!@#\$%\^\&*\)\(+=._-]/g, "");

    default:
      return value;
  }
};

export const getEffectiveYear = (year: any, yearOptions: any) => {
  if (Array.isArray(year)) return year;

  if (year === "All") {
    return yearOptions.filter((opt: any) => opt.id !== "All").map((opt: any) => opt.id);
  }
  return [year];
};

export const getSupplementalExportMeta = (reportPageName: string, dataLoadDate: any) => {
  const dateSuffix = moment(dataLoadDate).format('YYYYMMDD');

  const configMap: Record<string, { filePrefix: string; sheetName: string }> = {
    'AETNA-MEDICAL-SUPPLEMENTAL-DASHBOARD': {
      filePrefix: 'AETNA_Supplemental_Medical_Report',
      sheetName: 'Medical',
    },
    'AETNA-LAB-SUPPLEMENTAL-DASHBOARD': {
      filePrefix: 'AETNA_Supplemental_Lab_Report',
      sheetName: 'Lab',
    },
  };

  const config = configMap[reportPageName];

  if (!config) {
    throw new Error(`No export configuration found for ${reportPageName}`);
  }

  return {
    filename: `${config.filePrefix}_${dateSuffix}.xlsx`,
    sheetName: config.sheetName,
  };
};
